import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const Home = lazy(() => import('./pages/Home'));
const List = lazy(() => import('./pages/List'));
const Detail = lazy(() => import('./pages/Detail'));

const routers = createBrowserRouter([
  {
    path: '/',
    element: (
      <Suspense>
        <Home />
      </Suspense>
    ),
  },
  {
    path: '/list',
    element: (
      <Suspense>
        <List />
      </Suspense>
    ),
  },
  {
    path: '/game/:id',
    element: (
      <Suspense>
        <Detail />
      </Suspense>
    ),
  },
]);

const Router = () => {
  return <RouterProvider router={routers}></RouterProvider>;
};

export default Router;
